<template>
	<div id="MAM_terminalList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="formInline" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="formInline.phone" placeholder="请输入代理商账号"></el-input>
				</el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="formInline.real_name" placeholder="请输入代理商名称"></el-input>
                </el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="formInline.group_name" placeholder="请输入活动名称"></el-input>
                </el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="formInline.level_name" placeholder="请输入档位名称"></el-input>
                </el-form-item>
				<el-form-item>
					<el-select :editable="false" size="medium" v-model="formInline.status" filterable clearable style="width:100%"
						placeholder="请选择本月达标情况">
						<el-option label="进行中" value="10"></el-option>
						<el-option label="已达标" value="20"></el-option>
						<el-option label="未达标" value="30"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item>
                	<el-select :editable="false" size="medium" v-model="formInline.last_status" filterable clearable style="width:100%"
                		placeholder="请选择次月达标情况">
                        <el-option label="未开始" value="0"></el-option>
                		<el-option label="进行中" value="10"></el-option>
                		<el-option label="已达标" value="20"></el-option>
                		<el-option label="未达标" value="30"></el-option>
                	</el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        :editable="false"
                        size="medium"
                        v-model="formInline.date"
                        format="yyyy-MM"
                        value-format="yyyy-MM"
                        type="month"
                        placeholder="请选择考核日期">
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="报名开始日期"
                        end-placeholder="报名结束日期"
                        value-format="yyyy-MM-dd"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(formInline)">查询</el-button>
					<el-button size="medium" type="primary" icon="el-icon-download" style="font-size: 12px;" @click="downLoad(formInline)">导出数据</el-button>
                    <el-button size="medium" type="primary" icon="el-icon-download" style="font-size: 12px;" @click="downLoad2(formInline)">导出终端明细</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom: 10px; display: flex; align-items: center;">
                <el-button style="font-size: 12px;margin-right: 20px;" size="small" type="primary"
                	 @click="moreShen()">批量审核</el-button>
				<div class="tableTitle">
					<span class="st-label">上月达标人数：</span>
					<span
						class="st-word-aux">{{mainItem.last_month_reach_num}}人</span>
                    <span class="st-label" style="margin-left: 30px;">本月进行中人数：</span>
                    <span
                    	class="st-word-aux">{{mainItem.under_way_num}}人</span>
				</div>
			</div>
			<el-table  @selection-change="handleSelectionChange"  :data="transferList.list" size="mini" border style="width: 100%" v-loading="loading">
                <el-table-column :selectable="selectableFun" header-align="center"  align="center"  fixed type="selection"  min-width="80"></el-table-column>
				<!-- 代理商名称 -->
				<el-table-column header-align="center" align="center" prop="real_name" label="代理商名称"
					min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="phone" label="代理商账号"
					min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="level" label="代理商层级" min-width="120"></el-table-column>
                <el-table-column header-align="center" align="center" prop="sign_up_time" label="报名时间" min-width="160">
                </el-table-column>
				<!-- 考核月份 -->
				<el-table-column header-align="center" align="center" prop="date" label="考核月份"
					min-width="160"></el-table-column>
				<el-table-column header-align="center" align="center" prop="status_text" label="本月达标情况" min-width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 10" style="color: #E89E42;">{{scope.row.status_text}}</span>
                        <span v-if="scope.row.status == 20" style="color: #81B437;">{{scope.row.status_text}}</span>
                        <span v-if="scope.row.status == 30" style="color: #C72A29;">{{scope.row.status_text}}</span>
					</template>
				</el-table-column>
                <el-table-column header-align="center" align="center" prop="last_status_text" label="次月达标情况" min-width="120">
                	<template slot-scope="scope">
                        <span v-if="scope.row.last_status == 0" style="color: #E89E42;">{{scope.row.last_status_text}}</span>
                		<span v-if="scope.row.last_status == 10" style="color: #E89E42;">{{scope.row.last_status_text}}</span>
                        <span v-if="scope.row.last_status == 20" style="color: #81B437;">{{scope.row.last_status_text}}</span>
                        <span v-if="scope.row.last_status == 30" style="color: #C72A29;">{{scope.row.last_status_text}}</span>
                	</template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="group_name" label="活动名称" min-width="150">
                </el-table-column>
				<!-- 达标档位 -->
				<el-table-column header-align="center" align="center" prop="level_name" label="档位名称" min-width="150">
				</el-table-column>
				<!-- 月新增有效商户 -->
				<el-table-column header-align="center" align="center" prop="month_merchant_num" label="本月新增有效商户" min-width="120">
                    <template slot-scope="scope">
                        <span @click="detailClick(scope.row)" style="color: #5A9CF8;text-decoration: underline;">{{scope.row.month_merchant_num}}</span>
                    </template>
                </el-table-column>
				<!-- 同比上月新增交易量(万元) -->
				<el-table-column header-align="center" align="center" prop="merchant_average_money" label="本月户均交易量(万元)" min-width="160">
				</el-table-column>
                <el-table-column header-align="center" align="center" prop="merchant_active_ratio" label="本月新增商户活跃率(%)" min-width="150">
                    <template slot-scope="scope">
                        <span @click="detailActionClick(scope.row)" style="color: #5A9CF8;text-decoration: underline;">{{scope.row.merchant_active_ratio}}</span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="last_merchant_average_money" label="次月户均交易量(万元)" min-width="160">
                    <template slot-scope="scope">
                        <span @click="detailActionSecondClick(scope.row)" style="color: #5A9CF8;text-decoration: underline;">{{scope.row.last_merchant_average_money}}</span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="last_month_merchant_ratio" label="次月有效商户复刷率(%)" min-width="160">
                </el-table-column>
				<!-- 达标时间 -->
                <el-table-column header-align="center" align="center" prop="last_qualify_time" label="次月达标时间" min-width="160"></el-table-column>
				<el-table-column header-align="center" align="center" prop="qualify_time" label="达标时间" min-width="160"></el-table-column>
				<!-- 本次奖励金额(元) -->
				<el-table-column header-align="center" align="center" prop="reward_money" label="本次奖励金额(元)" min-width="150">
				</el-table-column>
                <el-table-column header-align="center" align="center" prop="send_time" label="发放时间" min-width="160">
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="reject_reason" label="驳回原因" min-width="160">
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="reject_time" label="驳回时间" min-width="160">
                </el-table-column>
                
				<!-- 操作 -->
				<el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="120">
					<template slot-scope="scope">
						<el-button v-if="scope.row.send_status == 2 && scope.row.status == 20 && scope.row.is_can_reward == 1" @click="sendClick(scope.row)" type="text" size="small">发放</el-button>
                        <el-button v-if="scope.row.send_status == 2 && scope.row.status == 20 && scope.row.is_can_reward == 1" @click="rejectClick(scope.row)" type="text" size="small">拒绝</el-button>
                        <el-button v-if="scope.row.send_status == 3 && scope.row.status == 20 && scope.row.is_can_reward == 1" @click="sendClick(scope.row)" type="text" size="small">重发</el-button>
						<span v-if="scope.row.send_status == 1">奖励已发</span>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize" style="text-align: center"></paginations>
		</el-card>
        
        <el-dialog width="40%" title="请填写驳回原因" :visible.sync="shibaiState" class="dialog">
        	<el-input
        	  clearable
        	  type="textarea"
        	  :rows="3"
        	  placeholder="请输入内容"
        	  :maxlength="30"
        	  v-model="textarea">
        	</el-input>
        	<div slot="footer" class="dialog-footer">
        	    <el-button  type="primary"  @click="trueBohuiClick">确定</el-button>
        	    <el-button   @click="shibaiState = false">取 消</el-button>
        	</div>
        </el-dialog>
        <el-dialog width="30%" title="批量审核发放" :visible.sync="moreShenState" class="dialog">
        	<span>确定要批量发放已勾选的达标记录吗？</span>
        	<div slot="footer" class="dialog-footer">
        	    <el-button :loading="downLoading"   type="primary"  @click="chuPayClick">全部通过并发放</el-button>
        	    <el-button   @click="moreShenState = false">取 消</el-button>
        	</div>
          
        </el-dialog>
        
	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "downSalaryAwardFinishList",
		data() {
			return {
				tableTitle: {
					total: 0, //总设备数
					total_bind: 0, //总绑定数
					total_active: 0, //总激活数
				},
				brandList: [],
				formInline: {
					real_name: '', //代理商名字
					phone: '', //代理商账号
                    date:'', // 达标月份
                    status:'' ,// 达标情况
                    last_status:'',// 次月打包情况
                    start_time:'',
                    end_time:'',
                    group_name:'',
                    level_name:''
				},
				transferList: {
					list: [],
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 0 //总数
				},
				loading: true,
                mainItem:{},
                rangeDate:[],
                multipleSelection:[],
                shibaiState:false,
                textarea:'',
                moreShenState:false,
                cellItem:{}
			}
		},
		mounted() {
			this.getData()
			this.$api.post('user_dividends/userManageRewardLevelPage', {
				page: 1,
				limit: 1000,
			}, res => { //获取管理奖规则
				if (res.code == 0) {
					this.brandList = res.data.list;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		components: {
			paginations,
		},
		methods: {
            pickerChange(DateArr) { //时间选择器
                this.formInline.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.formInline.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");

            },
            handleSelectionChange(rows){
            	this.multipleSelection = rows;
            },
            selectableFun(item){
            	if (item.send_status > 1 && item.status == 20 && item.is_can_reward == 1) {
            		return true
            	}else {
            		return false
            	}
            },
            moreShen(){
               if (this.multipleSelection.length == 0) {
               	this.$message({
               	    message: '请先选择要批量发放的数据!'
               	});
               	return;
               }else {
                   this.moreShenState = true
               }
            },
            
            rejectClick(item) {
                this.cellItem = item
                this.shibaiState = true
            },
            
            // 出款
            chuPayClick(){
            	let arr = []
            	for (let item of this.multipleSelection) {
            		arr.push(item.id)
            	}
                this.$api.post("user_dividends/sendRewardMoney", {record_id:arr.join(','),send_status:1,reward_type:3,reject_reason:this.textarea}, res => {
                    if (res.code == 0) {
                        this.$message.success(res.msg);
                        this.getData()
                    }else {
                        this.$message.error(res.msg);
                    }
                    this.onePayState = false
                    this.moreShenState = false
                })
            	
            	
            },
            
            trueBohuiClick(){
            	
            	if (this.textarea.length == 0) {
            		this.$message({
            		    message: '请输入备注'
            		});
            		return;
            	}
                this.$api.post("user_dividends/sendRewardMoney", {record_id:this.cellItem.id,send_status:3,reward_type:3,reject_reason:this.textarea}, res => {
                    if (res.code == 0) {
                        this.textarea = ''
                        this.$message.success(res.msg);
                        this.getData()
                    }else {
                        this.$message.error(res.msg);
                    }
                    this.moreShenState = false
                    this.shibaiState = false
                })
            	
            },
            sendClick(item) {
                this.$confirm('确定发放底薪奖吗？', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(()=>{
                	   this.$api.post("user_dividends/sendRewardMoney", {record_id:item.id,send_status:1,reward_type:3}, res => {
                		   if (res.code == 0) {
                			   this.$message.success(res.msg);
                			   this.getData()
                		   }else {
                			   this.$message.error(res.msg);
                		   }
                	   })
                	
                	
                }).catch(err=>{});
            },
            detailClick(item){
                this.$router.push({
                	path: '/effectiveMerchartList',
                	query: {
                		user_id: item.user_id,
                        date:item.date
                	}
                });
            },
            detailActionClick(item){
                this.$router.push({
                	path: '/ationSnDetailList',
                	query: {
                		user_id: item.user_id,
                        date:item.date,
                        record_id:item.id
                	}
                });
            },
            // 次月达标明细
            detailActionSecondClick(item) {
                this.$router.push({
                	path: '/ationSecondSnDetailList',
                	query: {
                        record_id:item.id
                	}
                });
            },
			onSearch() { //搜索
				this.page.currentPage = 1;
				// 表单提交
				this.getData()
			},
			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.getData();
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.getData()
			},
			getData() {
                this.formInline.page = this.page.currentPage
                this.formInline.limit = this.page.pageSize
				this.$api.post("user_dividends/signRecordList", this.formInline, res => {
					let data = res.data;
					this.page.total = data.total; //总数
					this.transferList.list = res.data.data;
                    this.mainItem = data
					//渲染结束后取消加载
					this.loading = false;
				})
			},
            downLoad2(formInline){
                if (formInline.date == '') {
                    this.$message.error('请先选择考核月份！');
                    return
                }
                let reqData = {
                	type: 31,
                	value: JSON.stringify(formInline)
                };
                
                this.downLoading = true;
                this.$api.post('export/add', reqData, res =>{
                	if (res.code == 0) {
                		this.$message.success(res.msg);
                		this.downLoading = false;
                	} else {
                		this.$message.error(res.msg);
                		this.downLoading = false;
                	}
                })
            },
			downLoad(formInline) { //导出
				let reqData = {
					type: 26,
					value: JSON.stringify(formInline)
				};

				this.downLoading = true;
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}

				})
			}
		}
	};
</script>





<style lang="scss" scope>
	.el-input__inner {
		font-size: 12px;
	}

	.el-form-item {
		margin-bottom: 5px;
	}

	.el-date-editor .el-range-input,
	.el-date-editor .el-range-separator {
		font-size: 12px;
	}

	.el-popover__title {
		font-size: 12px;
		font-weight: 700;
	}

	.MAM_terminalList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}

		.tableTitle {
			display: inline-block;
			margin-right: 20px;
		}
	}

	.terminal_operate {
		display: flex;
	}

	.el-button {
		font-size: 12px !important;
	}
</style>